export const INVOICE_TASK_LIST_SUCCESS='INVOICE_TASK_LIST_SUCCESS'
export const INVOICE_TASK_LIST_REQUEST='INVOICE_TASK_LIST_REQUEST'
export const INVOICE_TASK_LIST_FAIL='INVOICE_TASK_LIST_FAIL'

export const INVOICE_TASK_GET_SUCCESS='INVOICE_TASK_GET_SUCCESS'
export const INVOICE_TASK_GET_REQUEST='INVOICE_TASK_GET_REQUEST'
export const INVOICE_TASK_GET_FAIL='INVOICE_TASK_GET_FAIL'

export const INVOICE_TASK_CREATE_SUCCESS='INVOICE_TASK_CREATE_SUCCESS'
export const INVOICE_TASK_CREATE_REQUEST='INVOICE_TASK_CREATE_REQUEST'
export const INVOICE_TASK_CREATE_FAIL='INVOICE_TASK_CREATE_FAIL'
export const INVOICE_TASK_CREATE_RESET='INVOICE_TASK_CREATE_RESET'

export const INVOICE_TASK_UPDATE_SUCCESS='INVOICE_TASK_UPDATE_SUCCESS'
export const INVOICE_TASK_UPDATE_REQUEST='INVOICE_TASK_UPDATE_REQUEST'
export const INVOICE_TASK_UPDATE_FAIL='INVOICE_TASK_UPDATE_FAIL'
export const INVOICE_TASK_UPDATE_RESET='INVOICE_TASK_UPDATE_RESET'

export const INVOICE_TASK_DELETE_SUCCESS='INVOICE_TASK_DELETE_SUCCESS'
export const INVOICE_TASK_DELETE_REQUEST='INVOICE_TASK_DELETE_REQUEST'
export const INVOICE_TASK_DELETE_FAIL='INVOICE_TASK_DELETE_FAIL'
export const INVOICE_TASK_DELETE_RESET='INVOICE_TASK_DELETE_RESET'

export const INVOICE_TASK_REMINDER_OFF_SUCCESS='INVOICE_TASK_REMINDER_OFF_SUCCESS'
export const INVOICE_TASK_REMINDER_OFF_REQUEST='INVOICE_TASK_REMINDER_OFF_REQUEST'
export const INVOICE_TASK_REMINDER_OFF_FAIL='INVOICE_TASK_REMINDER_OFF_FAIL'
export const INVOICE_TASK_REMINDER_OFF_RESET='INVOICE_TASK_REMINDER_OFF_RESET'
